export const ITEM_POLLING_INTERVAL = 60000;
export const DELAY_TO_HAVE_REAL_TIME_DATA = 1000;
